import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Pages } from 'components/pages';
import { PermissionGuard } from 'components/permissions';
import Users from 'components/user';

const UsersRoute: React.FC = () =>
{
  return (
    <PermissionGuard
      permission={Users.Const.permissions.VIEW}
      fallback={<Pages.Page403 />}
    >
      <Routes>
        <Route path="/" element={<Pages.Users />} />
        <Route path="/page/:pageNum" element={<Pages.Users />} />
        <Route path="/page" element={<Pages.Users />} />
        <Route path="/:id/*" element={<Pages.User />} />
        <Route path="/create" element={<Pages.User />} />
      </Routes>
    </PermissionGuard>
  );
};

export default UsersRoute;